<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event.target.value)"
    fullscreen
    transition="dialog-bottom-transition"
  >
    <v-card color="primary" v-if="item.item">
      <AuditToolbar
        :title="`${item.item.category}  Audit`"
        :item="item"
        :totalItems="item.totalItems"
        @handlePrevItem="$emit('handlePrevItem', item.index )"
        @handleNextItem="$emit('handleNextItem', item.index )"
        @exit="$emit('input', false)"
      />
      <v-card color="primary" class="elevation-0">
        <v-card-text>
          <h2 class="pa-2 mt-5">Details</h2>
          <v-divider />
          <v-layout row class="mt-3">
            <v-flex>
              <h3 class="pa-2">Auditor: {{ item.item.auditor.name }}</h3>
              <h3 class="pa-2">Operator: {{ item.item.operator.name }}</h3>
              <h3 class="pa-2">Remarks: {{ item.item.remarks }}</h3>
            </v-flex>
            <v-flex>
              <h3 class="pa-2">Date: {{ localizeDate(item.item.dateCreated, true) }}</h3>
              <h3 class="pa-2">SKU: {{ item.item.sku }}</h3>
              <h3 class="pa-2">Lot: {{ item.item.lotNumber }}</h3>
            </v-flex>
          </v-layout>

          <span v-if="item.item.questionnaire.length">
            <h2 class="mt-4 pa-2">Questionnaire</h2>
            <v-divider />

            <v-layout row class="mt-4 pa-2 primary lighten-3">
              <v-flex xs4>
                <h3>Audit</h3>
              </v-flex>
              <v-flex xs4>
                <h3>Result</h3>
              </v-flex>
              <v-flex xs4>
                <h3>Comment</h3>
              </v-flex>
            </v-layout>
            <v-divider />
            <div v-for="(item, index) in item.item.questionnaire" :key="index">
              <v-layout row :class="index % 2 ? 'primary lighten-1 pa-2' : 'pa-2'">
                <v-flex xs4>
                  <h4>{{ item.question }}</h4>
                </v-flex>
                <v-flex xs4>
                  <h4
                    :style="{ color: item.responses.yes ? 'green' : 'red' }"
                  >{{ item.responses.yes ? "PASSED" : "FAILED" }}</h4>
                </v-flex>
                <v-flex xs4>
                  <h4>{{ item.responses.comments }}</h4>
                </v-flex>
              </v-layout>
            </div>
          </span>
          <h2 class="mt-4 pa-2">Chatter</h2>
          <v-divider />
          <Chatter v-if="value" reload :id="item.item._id" collection="quality" color="primary" />
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import AuditToolbar from "../AuditToolbar";
import Chatter from "../../app/chatter";
import Common from "@/mixins/Common";

export default {
  name: "Audit",

  props: ["value", "item"],

  computed: {
    ...mapGetters({
      audits: "audits/getAllAudits"
    })
  },

  components: {
    AuditToolbar,
    Chatter
  },

  watch: {
    value(val) {
      if (!val) {
        let search = this.item.search;
        this.$store.dispatch("audits/getAllAudits", search);
      }
    }
  },

  mixins: [Common]
};
</script>
